import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

import '../../scss/components/_modal.scss';

export default class Modal extends Component {
	blockClass = 'modal';

	handleClose = () => {
		if (this.props.onClose) {
			this.props.onClose();
		}
	};

	render() {
		const classes = [this.blockClass];
		if (this.props.className) {
			classes.push(this.props.className);
		}

		return (
			<div className={classes.join(' ')}>
				<a
					onClick={this.handleClose}
					className={`${this.blockClass}-close-button`}
					role="button"
					tabIndex={0}>
					<Icon type="close" />
				</a>
				<div className={`${this.blockClass}-content`}>{this.props.children}</div>
			</div>
		);
	}
}

Modal.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Modal.js